import {config} from "@shared/_services/config";
import {HTTP} from "../_helpers/http";

export default class EmployeeApi {
    static fetchAll() {
        return HTTP.get(config.employeeApi.employee)
            .then(response => response.data);
    }

    static fetchById(name) {
        return HTTP.get(`${config.employeeApi.employee}/${name}`)
            .then(response => response.data);
    }
}